import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

// Components
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import FeaturesSection from "./components/FeaturesSection";
import AllFeaturesSection from "./components/AllFeaturesSection";
import PricingSection from "./components/PricingSection";
import PricingDemoSection from "./components/PricingDemoSection";
import RepairHubSection from "./components/RepairHubSection";
import TestimonialsSection from "./components/TestimonialsSection";
import FAQSection from "./components/FAQSection";
import ContactSection from "./components/ContactSection";
import DownloadSection from "./components/DownloadSection";
import NewsletterSection from "./components/NewsletterSection";
import Footer from "./components/Footer";

// Pages
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import SupportPage from "./pages/SupportPage";

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

// Home Page
const HomePage = () => {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <FeaturesSection />
        <AllFeaturesSection />
        <PricingSection />
        <PricingDemoSection />
        <RepairHubSection />
        <TestimonialsSection />
        <FAQSection />
        <ContactSection />
        <DownloadSection />
        <NewsletterSection />
      </main>
      <Footer />
    </>
  );
};

function App() {
  return (
    <div className="min-h-screen bg-[#0F0F1A]" data-testid="app-container">
      {/* Noise overlay */}
      <div className="noise-overlay" />
      
      <BrowserRouter>
        <ScrollToTop />
        <Toaster 
          position="top-right" 
          toastOptions={{
            style: {
              background: '#1A1A2E',
              border: '1px solid rgba(255,255,255,0.1)',
              color: '#E2E8F0',
            },
          }}
        />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/support" element={<SupportPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
